import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './loading-admin-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrations: '<',
    selectedAdministrations: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    locked: '<',
    showHeader: '<'
  },
  controller: class LoadingAdminListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
      this.administrations = this.administrations.filter(a => a.Isloading === true);
    }

    $onChanges() {
      this.administrations = this.administrations.filter(a => a.Isloading === true);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/loading-admin-list/loading-admin-list.component.js